

export default class LoadMoreAjaxButtonLoader {

    constructor(){

        const html = document.querySelector( 'html' ) ;
        html.addEventListener( 'click', (e ) => { this.load_more_ajax_button_loader__handler( e ); } );
    }


    load_more_ajax_button_loader__handler( e ){

        let target_dataset = e.target.dataset ;

        // offer
        if( 'ajax-offer-loader' === target_dataset.click ){

            e.preventDefault();

            const url = new URL(window.location);

            let pages = 1 ;
            if( Number.isInteger( parseInt( url.searchParams.get("jobP[pages]") ) ) ){
                if( 1 < parseInt( url.searchParams.get("jobP[pages]") ) ){ pages = parseInt( url.searchParams.get("jobP[pages]") ) ; }
            }

            url.searchParams.set( 'jobP[pages]', ( pages + 1 ) );

            window.history.pushState({}, '', url );

        }

    }
}
